import { LinkBehaviourContext } from "@jti/ui/providers/LinkBehaviourContext";

import { NextLinkWrapper } from "../components/NextLinkWrapper";

type LinkBehaviourContextProviderProps = {
  children: React.ReactNode;
};

export const LinkBehaviourContextProvider = ({
  children,
}: LinkBehaviourContextProviderProps) => (
  <LinkBehaviourContext.Provider value={NextLinkWrapper}>
    {children}
  </LinkBehaviourContext.Provider>
);
